import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M21 19L21 5C21 3.9 19.9875 3 18.75 3L5.25 3C4.0125 3 3 3.9 3 5L3 19C3 20.1 4.0125 21 5.25 21L18.75 21C19.9875 21 21 20.1 21 19ZM5 19L5 5L19 5L19 19L5 19Z" fill="black"/>
</svg>
;
